export default __webpack_public_path__ + "static/Quickinstallation_Tile_8015_Step_01-f6c7aa8670a09dcff6d12fc6e14a967a.webp";